import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

// cn() doesn't merge classes: overriding a default here needs "!" (e.g. "!max-w-[600px]").

/** Standard page section: 105px / 6vw padding, 1180px content column. */
export function MarketingSection({
  id,
  className,
  innerClassName,
  children,
}: {
  id?: string;
  className?: string;
  innerClassName?: string;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      className={cn(
        "px-[6vw] py-[105px] text-marketing-ink max-[680px]:px-5 max-[680px]:py-[76px]",
        className,
      )}
    >
      <div className={cn("mx-auto w-[min(1180px,100%)]", innerClassName)}>
        {children}
      </div>
    </section>
  );
}

export function SectionKicker({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "mb-[14px] font-open-sans text-[14px] font-black uppercase tracking-[0.12em] text-blue-600",
        className,
      )}
    >
      {children}
    </p>
  );
}

export function SectionTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h2
      className={cn(
        "m-0 max-w-[920px] font-figtree text-[clamp(38px,5vw,64px)] font-black uppercase leading-[1.02] tracking-[-0.045em] [text-wrap:balance] max-[680px]:text-[clamp(36px,10vw,52px)]",
        className,
      )}
    >
      {children}
    </h2>
  );
}

export function SectionIntro({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "mt-[22px] max-w-[720px] font-open-sans text-[19px] leading-[1.55] text-marketing-muted",
        className,
      )}
    >
      {children}
    </p>
  );
}

/** Seafoam accent inside a heading. */
export function Accent({ children }: { children: ReactNode }) {
  return <span className="text-teal-500">{children}</span>;
}
